import * as React from "react";
const SvgFiRrSquareZ = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-z_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-4-1a1 1 0 0 1-1 1H8.132a2.12 2.12 0 0 1-1.973-1.316c-.324-.79-.14-1.69.471-2.292l9.378-8.246c-.023.02.007-.011-.017-.07-.031-.075-.095-.075-.123-.075H7.023a1 1 0 1 1 0-2h8.845c.871 0 1.645.517 1.973 1.316.324.79.14 1.69-.471 2.292L7.998 16.85c.009-.006-.01.023.011.075.031.075.095.075.123.075H17a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-z_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareZ;
